import { useCallback } from 'react';

type UseScrollToTargetOptions = {
  targetId?: string | undefined;
  offset?: number | undefined;
};

export const useScrollToTarget = ({ targetId, offset = 0 }: UseScrollToTargetOptions) => {
  return useCallback(() => {
    if (!targetId) return;

    const target = document.getElementById(targetId);

    if (!target) return;

    const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }, [targetId, offset]);
};
